<template>
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title">Especialidades Salvas</span>
  </div>
  <div class="container">
    <div class="container">
      <div class="row">
        <div class="col d-flex justify-content-end">
          <button @click="goToCreate()" class="btn btn-primary" style="margin-right: 10px; margin-bottom: 10px">Cadastrar Especialidades</button>
        </div>
      </div>
    </div>
    <a-table :dataSource="todasEspecialidades" :columns="columns">
      <template #nome="{ record }">
        <span>{{ stringNomeEspec(record) }}</span>
      </template>
      <template #action="{ record }">
        <a @click="removerEspecialidade(record)"><i class="fas fa-trash icon-trash"></i></a>
      </template>
    </a-table>
  </div>
</template>

<script>
import { deleteEspecialidade, getEspecialidades } from '@/components/service/especilidadeService';
import { openNotification, typesNotification } from '@/utils/notifications';

export default {
  name: 'PageEspecialidade',

  data() {
    return {
      todasEspecialidades: [],
      columns: [
        {
          title: 'Especialidade',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'nome' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    await this.getEspecialidades();
  },
  methods: {
    async getEspecialidades() {
      await getEspecialidades().then((esp) => {
        this.todasEspecialidades = esp.data;
      });
    },
    stringNomeEspec(obj) {
      return obj.especialidade.nome;
    },
    async removerEspecialidade(obj) {
      await deleteEspecialidade(obj.id).then(async () => {
        openNotification(typesNotification.success, 'Especialidade removida com sucesso.');
        await this.getEspecialidades();
      });
    },
    goToCreate() {
      this.$router.push('form-especialidade');
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

th {
  background-color: #f2f2f2;
}
</style>
